import { render } from "./CxScaleLegend.vue?vue&type=template&id=47153aa2"
import script from "./CxScaleLegend.vue?vue&type=script&lang=js"
export * from "./CxScaleLegend.vue?vue&type=script&lang=js"

import "./CxScaleLegend.vue?vue&type=style&index=0&id=47153aa2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__